/**
 * Component Registry for Via6
 * 
 * Inherits from @vibesites-weidner-apartment-homes/theme-via6 and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-weidner-apartment-homes/theme-via6/registry';
import { AmenitiesGrid } from './components/AmenitiesGrid';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PenthouseHero } from './components/PenthouseHero';
import { PenthouseSection } from './components/PenthouseSection';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Property-level AmenitiesGrid — forked from the parent theme so the
  // first amenity tile ships a Concierge service-bell icon instead of
  // the parent's "Scenic Swimming Pool" graphic. Editors can still
  // override any tile per-property via the inline editor.
  AmenitiesGrid,
  // Property-level Header — wraps the Weidner parent Header and
  // DOM-injects the new "Penthouse" link into the Features dropdown
  // (desktop + mobile drawer), since the parent's nav builder reads
  // pages.json via static imports that don't reach this property.
  Header,
  // Property-level Hero — plays property_featured_video as the
  // full-bleed background when set; falls back to featured image.
  Hero,
  // Property-level Penthouse hero — matches the per-page hero styling
  // used by sibling pages (FRCHero, PetPolicyHero, FloorPlansHero) by
  // delegating to the parent theme's shared `PageImageHeroBody`. This
  // replaces the generic `PageHero` previously wired on /penthouse so
  // the page title gets the brand left-aligned image hero instead of
  // the centered short banner.
  PenthouseHero,
  // Custom Via6 Penthouse page section — two-column layout (feature
  // collage + carousel container) used by the /penthouse page.
  PenthouseSection,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
